export enum AssetDownscaleStatuses {
    Submitted = 'Submitted',
    Progressing = 'Progressing',
    Complete = 'Complete',
    Canceled = 'Canceled',
    Error = 'Error',
}
